<template>
  <b-button
    class="
      d-flex
      justify-content-between
      align-items-center
      btn-show-data
      w-nowrap
      rounded-pill
    "
    id="btn-view-data"
    :class="isViewed ? 'view-data' : ''"
    @click="$emit('onViewData')"
  >
    <b-tooltip target="btn-view-data" triggers="hover">
      <div v-if="!isViewed">View Full Data</div>
      <div v-else>View Hide Data</div>
    </b-tooltip>
    <view-data-icon-svg v-if="!isViewed" class="icon-eye-svg" />
    <view-data-off-icon-svg v-else class="icon-eye-svg" />
  </b-button>
</template>

<script>
import ViewDataIconSvg from "@core/components/svg/common/ViewDataIcon.vue";
import ViewDataOffIconSvg from "@core/components/svg/common/ViewDataOffIcon.vue";
export default {
  props: {
    isViewed: { type: Boolean, default: false },
  },
  components: {
    ViewDataIconSvg,
    ViewDataOffIconSvg,
  },
};
</script>

<style scoped>
.icon-eye-svg {
  height: 24px;
  fill: #ffffff;
}

.btn-show-data {
  /* padding: 0.5rem 0.8rem;
  border-radius: 0.8rem; */
  padding: 0.5rem 0.3rem !important;
  border-radius: 8px !important;
  background-color: #c7cfce;
  border: 1px solid #c7cfce;
}

.view-data {
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  background: #00cfe8 !important;
  border: 1px solid #00cfe8 !important ;
}
</style>